module.exports = __webpack_public_path__ + "static/img/Nat_Fyfe_desktop.9857422.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nat_Fyfe_desktop.jpg
// module id = s38a
// module chunks = 0